import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 200]);
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-tx-midnight bg-noise pt-20" data-id="element-126">
      {/* Background Poster Image with Parallax */}
      <motion.div style={{
      y
    }} className="absolute inset-0 z-0" data-id="element-127">
        <div className="absolute inset-0 bg-gradient-to-b from-tx-midnight/40 via-tx-midnight/20 to-tx-midnight z-10" data-id="element-128" />
        <img src="https://cdn.magicpatterns.com/uploads/dEmFM4D9ZrU8EpRcU8HTxK/hero.jpg" alt="Texarkana Band Live Performance" className="w-full h-full object-cover object-center opacity-100" data-id="element-129" />
      </motion.div>

      <div className="relative z-20 max-w-5xl mx-auto px-4 flex flex-col items-center text-center mt-64 md:mt-48" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-131">
          <p className="text-xl md:text-3xl font-heading tracking-widest text-tx-parchmentLight/90 mb-8 uppercase text-shadow-md flex items-center gap-4" data-id="element-132">
            <span className="h-[1px] w-12 bg-tx-blue hidden md:block" data-id="element-133"></span>
            Southern Rock & Country • Live
            <span className="h-[1px] w-12 bg-tx-blue hidden md:block" data-id="element-134"></span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-135">
            <a href="#booking" className="w-full sm:w-auto" data-id="element-136">
              <Button size="lg" className="w-full" data-id="element-137">
                Book Us
              </Button>
            </a>
            <a href="#tour" className="w-full sm:w-auto" data-id="element-138">
              <Button variant="outline" size="lg" className="w-full" data-id="element-139">
                See Tour Dates
              </Button>
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2" data-id="element-140">
        <span className="font-body font-medium text-xs tracking-widest text-tx-parchmentLight/50 uppercase" data-id="element-141">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-tx-saddle relative overflow-hidden" data-id="element-142">
          <motion.div animate={{
          y: [0, 48, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'linear'
        }} className="absolute top-0 left-0 w-full h-1/2 bg-tx-blue" data-id="element-143" />
        </div>
      </motion.div>
    </section>;
}